import { Button } from "@design-lab/shared/ui";
import { type DesignUploadCookieData } from "@design-lab/shared/lib/designUploadCookie";

type ContinueSectionProps = {
  cookieArtwork: DesignUploadCookieData | null;
  latestProject: any;
  extractedProjectImages: { front: string; back: string };
  isLoading: boolean;
  isLoadingCookieArtwork?: boolean;
  onContinueWithCookie: () => void;
  onContinueWithLatest: () => void;
};

export function ContinueSection(props: ContinueSectionProps) {
  const {
    cookieArtwork,
    latestProject,
    extractedProjectImages,
    isLoading,
    isLoadingCookieArtwork = false,
    onContinueWithCookie,
    onContinueWithLatest
  } = props;

  // Show cookie artwork if available
  if (cookieArtwork) {
    return (
      <>
        <div className="flex justify-center">
          <div className="flex flex-col items-center gap-2">
            <div className="flex h-28 w-24 items-center justify-center overflow-hidden rounded-md border bg-white">
              <img
                src={cookieArtwork.url || cookieArtwork.original_image_url}
                alt="Recent upload"
                className="max-h-full max-w-full object-contain"
              />
            </div>
            <span className="text-sm font-medium">Recent Upload</span>
          </div>
        </div>
        <Button
          data-testid="start-designing-continue-cookie"
          variant="outline"
          onPress={onContinueWithCookie}
          className="h-12 w-44"
          isDisabled={isLoadingCookieArtwork}
        >
          {isLoadingCookieArtwork ? "Loading..." : "Continue Designing"}
        </Button>
      </>
    );
  }

  // Show loading state
  if (isLoading && !latestProject) {
    return (
      <div className="flex justify-center gap-4">
        {[0, 1].map(i => (
          <div key={i} className="flex flex-col items-center gap-2">
            <div className="h-28 w-24 animate-pulse rounded-md bg-blue-100" />
            <div className="h-4 w-16 animate-pulse rounded bg-blue-100" />
          </div>
        ))}
      </div>
    );
  }

  // Show latest project
  if (latestProject && (extractedProjectImages.front || extractedProjectImages.back)) {
    return (
      <>
        <div className="flex justify-center gap-4">
          {extractedProjectImages.front && (
            <div className="flex flex-col items-center gap-2">
              <div className="flex h-28 w-24 items-center justify-center overflow-hidden rounded-md border bg-white">
                <img
                  src={extractedProjectImages.front}
                  alt="Front preview"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <span className="text-sm font-medium">Front</span>
            </div>
          )}
          {extractedProjectImages.back && (
            <div className="flex flex-col items-center gap-2">
              <div className="flex h-28 w-24 items-center justify-center overflow-hidden rounded-md border bg-white">
                <img
                  src={extractedProjectImages.back}
                  alt="Back preview"
                  className="max-h-full max-w-full object-contain"
                />
              </div>
              <span className="text-sm font-medium">Back</span>
            </div>
          )}
        </div>
        <Button
          data-testid="start-designing-continue"
          variant="outline"
          onPress={onContinueWithLatest}
          className="h-12 w-44"
        >
          Continue Designing
        </Button>
      </>
    );
  }

  return null;
}
